import { useContext, useRef, useEffect } from 'react';
import {AppContext, AlertContext, OnlineStatusContext} from '../services'


const useApp = () => useContext(AppContext);
const useAlert =() => useContext(AlertContext)
const useOnlineStatus = () => useContext(OnlineStatusContext)

const  usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
}


export {useApp, useAlert, usePrevious, useOnlineStatus}
export * from './useLocalStorage'
export * from './toaster'